module.exports = __webpack_public_path__ + "assets/img/scjh.e6f3a020.png";